<template>
  <div :class="['message__area']">
    <div class="message__area-switcher">
      <Switcher
        size="small"
        :model="to_recruits"
        @switch="
          value => {
            to_recruits = value;
          }
        "
      />
      <p>Виден только рекрутерам</p>
    </div>
    <div class="message__area-input">
      <div class="message__editor">
        <Editor
          placeholder="Введите текст комментария. С помощью символа @ можно упомянуть пользователя"
          mentions
          :value="comment.content"
          :hiddenResizeIcon="true"
          :clearable="true"
          :recruits="to_recruits"
          :autosize="true"
          name="comment"
          :class="[editorError ? ' is-error' : '']"
          @leaveComment="leaveComment"
          @change="value => changeText(value)"
        />
      </div>

      <Button
        @click="leaveComment()"
        class="message__area-button"
        iconName="Send"
        buttonSize="big"
        hasLeftIcon
        buttonColor="blue"
        iconColor="#0075DB"
      />
    </div>
  </div>
</template>

<script>
import { mixin } from '@/utils/mixins';
import Editor from 'Elements/Editor/Editor';
import Switcher from 'Elements/Switch/Switch';
import Button from 'Elements/Button/Button';

export default {
  mixins: [mixin],
  components: {
    Button,
    Editor,
    Switcher
  },
  props: {
    error: {
      type: Boolean,
      default: false
    },
    commentToEdit: {
      type: Object,
      default: () => {}
    },
    mode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      editorError: this.error,
      comment: {
        ...this.commentToEdit
      },
      to_recruits: false,
      editorKey: 0,
      messageWasSent: false
    };
  },
  methods: {
    changeEditorKey() {
      this.editorKey++;
    },
    changeText(text) {
      this.editorError = false;
      this.messageWasSent = false;
      this.$set(this.comment, 'content', text);
    },
    leaveComment() {
      if (this.comment.content) {
        this.$emit(this.comment.id ? 'editComment' : 'leaveComment', {
          comment: this.comment,
          to_recruits: this.to_recruits
        });
        this.messageWasSent = true;
        this.comment.content = '';
      } else {
        this.editorError = true;
      }
    },
    getRecruitsValue(value) {
      if (!value || value == '0') return false;
      else return true;
    }
  },
  watch: {
    error(val) {
      this.editorError = val;
    },
    commentToEdit() {
      if (this.mode == 'selection') this.changeEditorKey();
      this.comment = {
        ...this.commentToEdit
      };
      this.to_recruits = this.getRecruitsValue(this.commentToEdit.to_recruits);
    }
  }
};
</script>
<style lang="scss" scoped>
.message__editor {
  width: 100%;
  margin-right: 8px;

  * {
    font-size: 15px;
  }

  & > .ck::after {
    background-image: none !important;
  }
}

.message__error {
  text-align: left;
  color: $red-700;
  margin: 14px 0;
}

.message__area {
  width: 100%;
  box-sizing: border-box;
  transition: 300ms;

  &_expanded {
    background: yellow !important;
    max-height: 268px;
  }

  &-input {
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    align-items: end;
    align-content: stretch;
  }

  &-switcher {
    width: 100%;
    margin-bottom: 16px;
    text-align: left;
    display: flex;

    p {
      margin-left: 16px;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: $grey80;
    }
  }
}
</style>
